export default function equalize () {
    function matchHeight () {   // eslint-disable-line
        const cols = document.querySelectorAll('[data-equalize]');
        const encountered = [];

        for (let i = 0; i < cols.length; i++) {
            const attr = cols[i].getAttribute('data-equalize');

            if (encountered.indexOf(attr) === -1) {
                encountered.push(attr);
            }
        }

        for (let set = 0; set < encountered.length; set++) {
            const col = document.querySelectorAll('[data-equalize="' + encountered[set] + '"]');
            const  group = [];

            for (let i = 0; i < col.length; i++) {
                col[i].style.height = 'auto';
                group.push(col[i].scrollHeight);
            }

            for (let n = 0; n < col.length; n++) {
                col[n].style.height = Math.max.apply(Math, group) + 'px';
            }
        }
    }

    matchHeight();

    setTimeout(() => {
        matchHeight(); // Dirty fix :)
    }, 500);

    window.addEventListener('resize', matchHeight);
}
